<template>
  <div>
    <h1 class="text-center my-5">Подписант договора</h1>

    <input-form-custom
      name="signer.second_name"
      v-model="signer.second_name"
      label="Фамилия"
    />
    <input-form-custom
      name="signer.first_name"
      v-model="signer.first_name"
      label="Имя"
    />
    <input-form-custom
      name="signer.third_name"
      v-model="signer.third_name"
      label="Отчество"
    />
    <input-form-custom
      name="signer.role"
      v-model="signer.role"
      label="Должность"
    />
    <div class="form-group">
      <label>Основание</label>
      <v-multiselect v-model="signer.base" :options="bases"name="signer.base"
                     data-vv-as="Основание"
                     v-validate="'required'"
      />
      <div v-if="errors.first('signer.base')" class="alert alert-danger">{{ errors.first('signer.base') }}</div>
    </div>
    <div v-if="selectedBase && selectedBase.ex" class="d-flex flex-row">
      <div class="flex-grow-1">
        <input-form-custom
          class="mr-3"
          name="signer.number"
          v-model="signer.number"
          :label="selectedBase.number"
        />
      </div>
      <div class="flex-grow-1" v-if="selectedBase.from">
        <label>Дата выдачи</label>
        <label class="input-group input-group-lg">
          <span class="input-group-prepend"><span class="input-group-text">От</span></span>
          <datepicker
            v-model="signer.from"
            name="signer.from"
            v-validate="'required'"
            data-vv-as="Дата выдачи">
          </datepicker>
        </label>
        <div v-if="errors.first('signer.from')" class="alert alert-danger">{{ errors.first('signer.from') }}</div>
      </div>
  </div>
  </div>
</template>
<script>
  import {omit} from 'lodash'

  export default {
    inject: {
      $validator: '$validator'
    },
    props: {
      value: {},
    },
    data () {
      return {
        signer: this.value ? this.value : {},
        bases: [
          'Устав',
          'Доверенность',
          'Свидетельство о гос. регистрации ФЛ в качестве ИП',
          'Основной гос. регистрационный номер ИП',
        ],
        basesData: [
          {
            name: 'Устав',
            ex: false,
            from: false,
          },
          {
            name: 'Доверенность',
            ex: true,
            number: 'Номер доверенности',
            from: true,
          },
          {
            name: 'Свидетельство о гос. регистрации ФЛ в качестве ИП',
            ex: true,
            number: 'Серия, номер',
            from: true,
          },
          {
            name: 'Основной гос. регистрационный номер ИП',
            ex: true,
            number: 'Номер',
            from: false,
          },
        ],
      }
    },
    watch: {
      signer () {
        let data = this.signer
        if (this.selectedBase) {
          data = this.selectedBase.ex ? data : omit(data, ['number'])
          data = this.selectedBase.from ? data : omit(data, ['from'])
        }
        this.$emit('input', data)
      },
    },
    computed: {
      selectedBase () {
        return this.signer.base ? this.basesData.find((el) => { return el.name === this.signer.base }) : false
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/personal/signatory.vue